/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeDRadiusUpLeftIcon16Light } from './ArrowShapeDRadiusUpLeftIcon16Light';
import { ArrowShapeDRadiusUpLeftIcon16Regular } from './ArrowShapeDRadiusUpLeftIcon16Regular';
import { ArrowShapeDRadiusUpLeftIcon16Solid } from './ArrowShapeDRadiusUpLeftIcon16Solid';
import { ArrowShapeDRadiusUpLeftIcon20Light } from './ArrowShapeDRadiusUpLeftIcon20Light';
import { ArrowShapeDRadiusUpLeftIcon20Regular } from './ArrowShapeDRadiusUpLeftIcon20Regular';
import { ArrowShapeDRadiusUpLeftIcon20Solid } from './ArrowShapeDRadiusUpLeftIcon20Solid';
import { ArrowShapeDRadiusUpLeftIcon24Regular } from './ArrowShapeDRadiusUpLeftIcon24Regular';
import { ArrowShapeDRadiusUpLeftIcon24Solid } from './ArrowShapeDRadiusUpLeftIcon24Solid';
import { ArrowShapeDRadiusUpLeftIcon32Regular } from './ArrowShapeDRadiusUpLeftIcon32Regular';
import { ArrowShapeDRadiusUpLeftIcon64Regular } from './ArrowShapeDRadiusUpLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeDRadiusUpLeftIcon16Light,
        regular: ArrowShapeDRadiusUpLeftIcon16Regular,
        solid: ArrowShapeDRadiusUpLeftIcon16Solid,
    },
    20: {
        light: ArrowShapeDRadiusUpLeftIcon20Light,
        regular: ArrowShapeDRadiusUpLeftIcon20Regular,
        solid: ArrowShapeDRadiusUpLeftIcon20Solid,
    },
    24: {
        regular: ArrowShapeDRadiusUpLeftIcon24Regular,
        solid: ArrowShapeDRadiusUpLeftIcon24Solid,
    },
    32: {
        regular: ArrowShapeDRadiusUpLeftIcon32Regular,
    },
    64: {
        regular: ArrowShapeDRadiusUpLeftIcon64Regular,
    },
};
export var ArrowShapeDRadiusUpLeftIcon = forwardRef('ArrowShapeDRadiusUpLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
